import React, { useState } from 'react';
import Papa from 'papaparse';

const ImagesViewer = () => {

    const [imageIds, setImageIds] = useState([]);

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                complete: (results) => {
                    const imageIds = results.data
                        .map(row => {
                            const match = row['@message']?.match(/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}/);
                            return match ? match[0] : null;
                        })
                        .filter(Boolean);
                    setImageIds(imageIds);
                },
                error: (error) => {
                    console.error('Error parsing CSV:', error);
                }
            });
        }
    };

    return (
        <div>
            <h1>Input</h1>
            <input
                type="file"
                accept=".csv"
                onChange={handleFileUpload}
                style={{ marginBottom: '20px' }}
            />
            <h2>Images</h2>
            {imageIds.map((imageId, index) => (
                <img key={index} src={`https://d3qqvwfuhovcx5.cloudfront.net/${imageId}.png`} alt={`Image ${index + 1}`} style={{ margin: '10px', maxWidth: '200px' }} />
            ))}
        </div>
    );
};

export default ImagesViewer;